import { DotsHorizontalIcon } from "@radix-ui/react-icons";
import { Edit, Power, PowerOff, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Provider } from "@shared/validators/admin/settings-validators";

interface ProviderActionsProps {
    provider: Provider;
    onEdit?: (provider: Provider) => void;
    onToggleEnabled?: (provider: Provider) => void;
    onDuplicate?: (provider: Provider) => void;
}

export function ProviderActions({ provider, onEdit, onToggleEnabled, onDuplicate }: ProviderActionsProps) {
    const handleToggleEnabled = () => {
        if (!onToggleEnabled) return;
        onToggleEnabled(provider);
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button aria-label="Open menu" variant="ghost" className="flex h-8 w-8 p-0 data-[state=open]:bg-muted">
                    <DotsHorizontalIcon className="h-4 w-4" aria-hidden="true" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-[160px]">
                <DropdownMenuItem onClick={() => onEdit?.(provider)}>
                    <Edit className="mr-2 h-4 w-4" />
                    Edit
                </DropdownMenuItem>
                <DropdownMenuItem onClick={() => onDuplicate?.(provider)}>
                    <Copy className="mr-2 h-4 w-4" />
                    Duplicate
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={handleToggleEnabled}>
                    {provider.enabled ? (
                        <>
                            <PowerOff className="mr-2 h-4 w-4" />
                            Disable
                        </>
                    ) : (
                        <>
                            <Power className="mr-2 h-4 w-4" />
                            Enable
                        </>
                    )}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
